import React, { Component } from "react";

class Header extends Component {
  render() {
    return (
      <div className="header">
        <h1>Hacker News!</h1>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js